// src/theme/atomic/violet.ts
var violet = {
  10: "#11024D",
  20: "#23098F",
  30: "#3A16C9",
  40: "#4F29E5",
  50: "#6541F2",
  60: "#7D5EF7",
  70: "#9E86FC",
  80: "#C0B0FF",
  90: "#DBD3FE",
  95: "#F0ECFE",
  99: "#FBFAFF"
};
var violet_default = violet;

export { violet_default as default };
